export default {
  backButton: 'Practice Group Report',
};
